import { type HealthStatus } from "@/infra/observability/performance/healthPolicies";

const TAURI_EVENTS = {
  NETWORK_STATUS_CHANGE: "network-status-change",
  DEEP_LINK_DETECTED: "deep-link-detected",
  MEMORY_STATUS_UPDATE: "memory-status-update",
} as const;

type NetworkStatusChangeEventPayload = "Online" | "Offline";
type DeepLinkDetectedEventPayload = { url: string };
type MemoryUsageEventPayload = {
  availableMemory: number;
  memoryHealth: HealthStatus;
};

export {
  TAURI_EVENTS,
  type NetworkStatusChangeEventPayload,
  type DeepLinkDetectedEventPayload,
  type MemoryUsageEventPayload,
};
